export default __webpack_public_path__ + "static/media/nibbleSlide3.cf94a280.png";